import { FreeCamera, Vector3, HemisphericLight, MeshBuilder, Scene, Mesh, HavokPlugin, PhysicsAggregate, PhysicsShapeType, FollowCamera, StandardMaterial, Color3, Space, Axis, Angle, DirectionalLight, ActionManager, HDRCubeTexture, Sound, Color4, NodeMaterial, ShadowGenerator, Quaternion, Texture, ParticleSystem, ParticleHelper, TransformNode, CubeTexture, GroundMesh, SceneLoader, Node } from "@babylonjs/core";
import HavokPhysics from "@babylonjs/havok";
import { Inspector } from '@babylonjs/inspector';
import { line2D } from "../../utils/line2d";
import { Game } from "../Game";
import { Player } from "./Player";
import { Door } from "./Door";
import { Ramp } from "./Ramp";
import { Chronometer } from "../../utils/Chronometer";
import { Controls } from "../../core/Controls";
import snowTexture from "../../textures/snow.jpg"
import barrierTexture from "../../textures/mesh_pattern_orange.png"
import snowTextureN from "../../textures/snow_n.png"
import snowParticles from "../../particles/snow.json"
import driftSfx from "../../sfx/snow_loop.wav"
import cheeringSfx from "../../sfx/cheering.wav"
import cheerloopSfx from "../../sfx/cheer_loop.wav"
import bellsSfx from "../../sfx/cow_bells.wav"
import coldWindSfx from "../../sfx/smooth-cold-wind-looped-135538.mp3"
import startSfx from "../../sfx/success.wav"
import { Boost } from "./Boost";
import { getRandomInt } from "../../core/utils";


export function isOnMobile() {
  let check = false;
  (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true; })(navigator.userAgent || navigator.vendor);
  return check;
};

export const DEBUG_MODE = false;
export class SkiSlalomGame implements Game {

  gameReady = false

  player: Player | null = null
  ground: Mesh | null = null
  nextDoor: Door | null = null
  doors: Door[] = []

  nextRamp: Ramp | null = null
  ramps: Ramp[] = []

  nextBoost: Boost | null = null
  boosts: Boost[] = []

  SLOPE_LENGTH = 8000;
  SLOPE_ANGLE_RAD = Angle.FromDegrees(0).radians()
  SLOPE_WIDTH = 80;
  GROUND_WIDTH = 5000;
  MAX_DISTANCE_BETWEEN_DOORS = 200;
  MIN_DISTANCE_BETWEEN_DOORS = 100;
  chrono: Chronometer;
  controls: Controls;

  driftSound: Sound | null = null
  backgroundSound: Sound | null = null
  cheeringSound: Sound | null = null;
  cheerloopSound: Sound | null = null;
  bellSound: Sound | null = null;
  startSound: Sound | null = null;

  scene: Scene | null = null
  camera: FreeCamera | FollowCamera | null = null;
  finished: boolean = false;

  _pineTreeMesh1: Mesh | null = null;
  _pineTreeMesh2: Mesh | null = null;
  _pineTreeMesh3: Mesh | null = null;
  _barrierMesh: Mesh | null = null;
  _rockMesh1: Mesh | null = null;
  _rockMesh2: Mesh | null = null;
  _rockMesh3: Mesh | null = null;
  _olympicFlagMesh: Mesh | null = null;
  finishLine: Mesh | null = null;
  onGameFinished: undefined | ((score: number) => void)
  physicsPlugin: HavokPlugin | null = null;
  gravityVector: Vector3 | null = null;
  constructor() {
    this.chrono = new Chronometer()
    this.controls = new Controls();
  }


  restart = () => {
    window.location.reload();
    // if (this.scene) {
    // this.scene.getPhysicsEngine()?.setTimeStep(0);
    // this.player!.mesh.position = new Vector3(0, 0, 0);
    // this.chrono.stop()
    // this.gameStarted = false;
    // this.finished = false;
    // this.scene.getPhysicsEngine()?.setTimeStep(1 / 60);

    // const newScene = new Scene(this.scene.getEngine());
    //dispose the old scene
    // this.scene.disablePhysicsEngine()
    // if (this.physicsPlugin) this.scene.enablePhysics(this.gravityVector, this.physicsPlugin);
    // this.scene.physicsEnabled = true;
    // this.scene.dispose();
    //show new scne
    // console.log(newScene);
    // this.onStart(newScene)
    // this.scene.getEngine().runRenderLoop(() => {
    //   newScene.render();
    // });
    // }
  }

  onStart = async (scene: Scene) => {
    window.onresize = () => {
      scene.getEngine().resize();
    }
    this.scene = scene;

    // Create default camera to avoid warning
    this.camera = new FreeCamera("default", new Vector3(0, 0, 0), scene);

    // PHYSICS
    this.physicsPlugin = new HavokPlugin(true, await HavokPhysics());
    this.physicsPlugin.setTimeStep(1 / 60);
    this.gravityVector = new Vector3(0, -200, 0);
    scene.enablePhysics(this.gravityVector, this.physicsPlugin);
    scene.physicsEnabled = false;
    scene.onBeforeStepObservable.add(this.onPhysicsUpdate);

    // setInterval(() => {
    //   this.onPhysicsUpdate(scene);
    // }, 10);


    if (DEBUG_MODE) Inspector.Show(scene, { embedMode: false, });

    // SCENE ENVIRONMENT
    const sunLight = new DirectionalLight("sun", new Vector3(1, -1, 1), scene);
    sunLight.diffuse = Color3.FromHexString("#FFF3C0")
    sunLight.position = new Vector3(0, 1000, 0)
    sunLight.intensity = 3;
    const ambiantLight = new HemisphericLight("ambiant", new Vector3(0, 1, 0), scene);
    ambiantLight.diffuse = Color3.FromHexString("#C5C5FF")
    ambiantLight.intensity = 3;
    scene.clearColor = new Color4(0, 0, 0, 0);
    // scene.environmentTexture = new HDRCubeTexture("https://assets.babylonjs.com/environments/Snow_Man_Scene/winter_lake_01_1k.hdr", scene, 128, false, true, false, true);
    // scene.clearColor = new Color4(0.72, 0.85, 0.98, 1.0)
    this.backgroundSound = new Sound("WinterSounds", coldWindSfx, scene, () => {
      this.backgroundSound!.play(0);
    }, { loop: true, autoplay: true, volume: 0.5 });
    this.driftSound = new Sound("driftSfx", driftSfx, scene);
    this.driftSound.loop = true;
    this.driftSound.autoplay = false;

    this.cheeringSound = new Sound("cheeringSfx", cheeringSfx, scene);
    this.cheeringSound.loop = false;
    this.cheeringSound.autoplay = false;

    this.cheerloopSound = new Sound("cheerloopSfx", cheerloopSfx, scene);
    this.cheerloopSound.loop = true;
    this.cheerloopSound.autoplay = false;

    this.bellSound = new Sound("bellSfx", bellsSfx, scene);
    this.bellSound.loop = true;
    this.bellSound.autoplay = false;

    this.startSound = new Sound("startSfx", startSfx, scene);
    this.startSound.loop = false;

    // Skybox
    const skybox = MeshBuilder.CreateBox("skyBox", { size: 10000.0 }, scene);
    const skyboxMaterial = new StandardMaterial("skyBox", scene);
    skyboxMaterial.backFaceCulling = false;
    // skyboxMaterial.reflectionTexture = new CubeTexture("./skybox/TropicalSunnyDay", scene, ["_px.jpg", "_py.jpg", "_pz.jpg", "_nx.jpg", "_ny.jpg", "_nz.jpg"]);
    skyboxMaterial.reflectionTexture = new CubeTexture("./skybox/skybox", scene, ["_px.png", "_py.png", "_pz.png", "_nx.png", "_ny.png", "_nz.png"]);
    skyboxMaterial.reflectionTexture.coordinatesMode = Texture.SKYBOX_MODE;
    skyboxMaterial.diffuseColor = new Color3(0, 0, 0);
    skyboxMaterial.specularColor = new Color3(0, 0, 0);
    skyboxMaterial.disableLighting = true;
    skybox.material = skyboxMaterial;
    skybox.renderingGroupId = 0;
    skybox.infiniteDistance = true;
    skybox.rotate(Axis.Y, Angle.FromDegrees(220).radians(), Space.WORLD)
    // skybox.rotate(Axis.X, Angle.FromDegrees(30).radians(), Space.WORLD)

    // Fog
    scene.fogMode = Scene.FOGMODE_EXP2;
    scene.fogDensity = 0.0001;
    scene.fogColor = Color3.White();

    this.player = new Player(scene, new Vector3(0, 0, -10));
    await this.player.init(scene)

    // CAMERA
    this.camera.dispose()
    if (DEBUG_MODE) {
      // creates and positions a free camera (non-mesh)
      this.camera = new FreeCamera("FreeCamera", new Vector3(0, 1000, this.SLOPE_LENGTH / 2), scene);
      this.camera.setTarget(new Vector3(0, 0, this.SLOPE_LENGTH));
      // attaches the camera to the canvas
      this.camera.attachControl(false);
      scene.debugLayer.show({})
    }
    else {
      this.camera = new FollowCamera("FollowCam", new Vector3(0, 0, -100), scene);
      this.camera.radius = 1;
      this.camera.heightOffset = 3;
      this.camera.rotationOffset = 180;
      this.camera.cameraAcceleration = 0.01;
      this.camera.maxCameraSpeed = 1000;
      this.camera.lockedTarget = this.player.mesh;
      this.camera.lowerRadiusLimit = 20;
      this.camera.upperRadiusLimit = 30;
      // this.camera.attachControl(true);
    }

    // snow
    const snowPS = ParticleSystem.Parse(snowParticles, scene, "", false, 1000);
    const snowTransform = new Mesh("rainTransform", scene)
    snowTransform.parent = this.camera;
    snowTransform.position = new Vector3(0, 40, 25)
    snowPS.emitter = snowTransform;
    snowPS.start()

    const snowWorldPS = ParticleSystem.Parse(snowParticles, scene, "", false, 1000);
    const snowTransformWorld = new Mesh("rainTransformWorld", scene)
    snowTransformWorld.parent = this.camera;
    snowTransformWorld.position = new Vector3(0, 100, 150)
    snowWorldPS.emitter = snowTransformWorld;
    snowWorldPS.start()


    // Ground
    this.ground = MeshBuilder.CreateGround("ground", { width: this.GROUND_WIDTH, height: this.SLOPE_LENGTH + 10000 }, scene);
    this.ground.rotate(Axis.X, this.SLOPE_ANGLE_RAD, Space.LOCAL);
    const GROUND_SHIFT_POS = new Vector3(0, -1, -5)
    this.ground.position = new Vector3(0 + GROUND_SHIFT_POS.x, -Math.sin(this.SLOPE_ANGLE_RAD) * (this.SLOPE_LENGTH / 2) + GROUND_SHIFT_POS.y, Math.cos(this.SLOPE_ANGLE_RAD) * (this.SLOPE_LENGTH / 2) + GROUND_SHIFT_POS.z)
    // const groundMat = new StandardMaterial("groundMat");
    // groundMat.diffuseColor = Color3.White();
    // ground.material = groundMat;
    const groundmat = new StandardMaterial("groundMat");
    const texture = new Texture(snowTexture, scene);
    groundmat.alpha = 1
    const tilling = 6
    texture.uScale = tilling * 1.0;
    texture.vScale = tilling * 6.0;
    groundmat.diffuseTexture = texture;
    const detailMapTexture = new Texture(snowTextureN, scene);
    detailMapTexture.uScale = tilling * 1.0;
    detailMapTexture.vScale = tilling * 6.0;
    groundmat.detailMap.texture = detailMapTexture
    groundmat.detailMap.isEnabled = true;
    this.ground.material = groundmat;

    // RENDERING
    var shadowGenerator = new ShadowGenerator(1024, sunLight);
    shadowGenerator.addShadowCaster(this.player.mesh);
    shadowGenerator.useBlurExponentialShadowMap = true;
    this.ground.receiveShadows = true;

    // DECOR (pine trees, rocks, barriers)
    const decorsParent = MeshBuilder.CreateBox("decors", { size: 1 }, scene);
    decorsParent.isVisible = false
    const resourcesParent = MeshBuilder.CreateBox("_resources", { size: 1 }, scene);
    resourcesParent.isVisible = false
    if (this._pineTreeMesh1 == null) {
      this._pineTreeMesh1 = (await SceneLoader.ImportMeshAsync("", "./models/", "low_poly_pine_tree1.glb", scene)).meshes[0] as Mesh;
      this._pineTreeMesh1.getChildMeshes().forEach(mesh => mesh.isVisible = false);
      this._pineTreeMesh1.name = "_tree1";
      this._pineTreeMesh1.parent = resourcesParent
      this._pineTreeMesh1.isVisible = false
    }
    if (this._pineTreeMesh2 == null) {
      this._pineTreeMesh2 = (await SceneLoader.ImportMeshAsync("", "./models/", "low_poly_pine_tree2.glb", scene)).meshes[0] as Mesh;
      this._pineTreeMesh2.getChildMeshes().forEach(mesh => mesh.isVisible = false);
      this._pineTreeMesh2.name = "_tree2";
      this._pineTreeMesh2.parent = resourcesParent
      this._pineTreeMesh2.isVisible = false
    }
    if (this._pineTreeMesh3 == null) {
      this._pineTreeMesh3 = (await SceneLoader.ImportMeshAsync("", "./models/", "low_poly_pine_tree3.glb", scene)).meshes[0] as Mesh;
      this._pineTreeMesh3.getChildMeshes().forEach(mesh => mesh.isVisible = false);
      this._pineTreeMesh3.name = "_tree3";
      this._pineTreeMesh3.parent = resourcesParent
      this._pineTreeMesh3.isVisible = false
    }
    if (this._rockMesh1 == null) {
      this._rockMesh1 = (await SceneLoader.ImportMeshAsync("", "./models/", "rock0.glb", scene)).meshes[0] as Mesh;
      this._rockMesh1.name = "_rock0"
      this._rockMesh1.getChildMeshes().forEach(mesh => mesh.isVisible = false);
      this._rockMesh1.parent = resourcesParent
      this._rockMesh1.isVisible = false
    }
    if (this._rockMesh2 == null) {
      this._rockMesh2 = (await SceneLoader.ImportMeshAsync("", "./models/", "rock1.glb", scene)).meshes[0] as Mesh;
      this._rockMesh2.name = "_rock1"
      this._rockMesh2.parent = resourcesParent
      this._rockMesh2.isVisible = false
      this._rockMesh2.getChildMeshes().forEach(mesh => mesh.isVisible = false);
    }
    if (this._rockMesh3 == null) {
      this._rockMesh3 = (await SceneLoader.ImportMeshAsync("", "./models/", "rock2.glb", scene)).meshes[0] as Mesh;
      this._rockMesh3.name = "_rock2"
      this._rockMesh3.getChildMeshes().forEach(mesh => mesh.isVisible = false);
      this._rockMesh3.parent = resourcesParent
      this._rockMesh3.isVisible = false
    }
    if (this._olympicFlagMesh == null) {
      this._olympicFlagMesh = (await SceneLoader.ImportMeshAsync("", "./models/", "olympic_flag.glb", scene)).meshes[0] as Mesh;
      this._olympicFlagMesh.name = "_olympicflag"
      this._olympicFlagMesh.getChildMeshes().forEach(mesh => mesh.isVisible = false);
      this._olympicFlagMesh.parent = resourcesParent
      this._olympicFlagMesh.isVisible = false
    }

    const rocksParent = MeshBuilder.CreateBox("rocks", { size: 1 }, scene);
    rocksParent.isVisible = false
    rocksParent.parent = decorsParent

    const treeParent = MeshBuilder.CreateBox("tree", { size: 1 }, scene);
    treeParent.isVisible = false
    treeParent.parent = decorsParent
    const treeModelsToSpawn = [this._pineTreeMesh1, this._pineTreeMesh2]//, this._pineTreeMesh3]
    const rockModelsToSpawn = [this._rockMesh1, this._rockMesh2, this._rockMesh3]
    const elementsNumber = isOnMobile() ? 30 : 300;
    for (let i = 0; i < this.SLOPE_LENGTH + 100; i += this.SLOPE_LENGTH / elementsNumber) {
      let meshToClone: Mesh = treeModelsToSpawn[getRandomInt(0, treeModelsToSpawn.length - 1)]
      const newTreeInstance = meshToClone.clone(meshToClone.name + "-" + i);
      meshToClone.getChildMeshes().forEach(mesh => {
        const instance = (mesh as Mesh).createInstance(mesh.name + "-" + i)
        instance.isVisible = true;
        instance.parent = newTreeInstance;
      });
      const treeScale = 0.2 + Math.random() * 0.4
      newTreeInstance.scaling = new Vector3(treeScale, treeScale, treeScale)
      newTreeInstance.position.y = -1.25;
      newTreeInstance.position.z = i + Math.random() * 10;
      newTreeInstance.position.x = Math.random() >= 0.5 ? (this.SLOPE_WIDTH / 2) + 80 + Math.random() * 100 : -(this.SLOPE_WIDTH / 2) - 80 - Math.random() * 100;
      newTreeInstance.isVisible = true;
      newTreeInstance.rotate(newTreeInstance.right, Angle.FromDegrees(-15 - Math.random() * 10).radians())
      newTreeInstance.rotate(newTreeInstance.up, Angle.FromDegrees(Math.random() * 360).radians())
      newTreeInstance.rotate(newTreeInstance.forward, Angle.FromDegrees(-5 + Math.random() * 10).radians())
      newTreeInstance.receiveShadows = false;
      newTreeInstance.parent = treeParent;

      // ROCKS
      let rockMeshToClone: Mesh = rockModelsToSpawn[getRandomInt(0, rockModelsToSpawn.length - 1)]
      const newRockInstance = rockMeshToClone.clone(rockMeshToClone.name + "-" + i);
      rockMeshToClone.getChildMeshes().forEach(mesh => {
        const instance = (mesh as Mesh).createInstance(mesh.name + "-" + i)
        instance.isVisible = true;
        instance.parent = newRockInstance;
      });
      const rockScale = 0.5 + Math.random() * 0.4
      newRockInstance.scaling = new Vector3(rockScale + Math.random() * 2, rockScale, rockScale + Math.random() * 2)
      newRockInstance.position.y = -1.25 - Math.random() * 5;
      newRockInstance.position.z = i + Math.random() * 10;
      newRockInstance.position.x = Math.random() >= 0.5 ? (this.SLOPE_WIDTH / 2) + 80 + Math.random() * 300 : -(this.SLOPE_WIDTH / 2) - 80 - Math.random() * 300;
      newRockInstance.isVisible = true;
      // newRockInstance.rotate(newRockInstance.right, Angle.FromDegrees(-15 - Math.random() * 10).radians())
      newRockInstance.rotate(newRockInstance.up, Angle.FromDegrees(Math.random() * 360).radians())
      // newRockInstance.rotate(newRockInstance.forward, Angle.FromDegrees(-5 + Math.random() * 10).radians())
      newRockInstance.receiveShadows = false;
      newRockInstance.parent = rocksParent;
    }

    if (!isOnMobile()) {
      let isRightSide = true;
      for (let i = 0; i < this.SLOPE_LENGTH; i += this.SLOPE_LENGTH / 20) {
        const newOlympicFlagInstance = this._olympicFlagMesh.clone("olympicflag-" + i);
        this._olympicFlagMesh.getChildMeshes().forEach(mesh => {
          const instance = (mesh as Mesh).createInstance(mesh.name + "-" + i)
          instance.isVisible = true;
          instance.parent = newOlympicFlagInstance;
        });
        newOlympicFlagInstance.position.x = (isRightSide ? 1 : -1) * ((this.SLOPE_WIDTH + 100) / 2);
        newOlympicFlagInstance.position.z = i;
        newOlympicFlagInstance.position.y = -1.25;
        newOlympicFlagInstance.isVisible = true;
        newOlympicFlagInstance.scaling = new Vector3(4, 4, 4)
        newOlympicFlagInstance.rotate(newOlympicFlagInstance.up, Angle.FromDegrees(isRightSide ? 135 : 45).radians())
        newOlympicFlagInstance.rotate(newOlympicFlagInstance.forward, Angle.FromDegrees(-10).radians())
        newOlympicFlagInstance.parent = decorsParent;
        isRightSide = !isRightSide;
      }
    }

    const groundAggregate = new PhysicsAggregate(this.ground, PhysicsShapeType.BOX, { mass: 0, friction: 0, restitution: 0 }, scene);

    // SLALOM
    let path: Vector3[] = [];
    let doorIndex = 0;
    let spaceBetween = 150
    let startPosZ = -this.SLOPE_LENGTH / 2 + spaceBetween * 2
    let length = 1000;

    await this.generateLine(path, doorIndex, startPosZ, length, this.SLOPE_WIDTH / 4, (x) => Math.sin(x * 0.01)); // very simple sine
    startPosZ += length + spaceBetween;

    await this.generateLine(path, doorIndex, startPosZ, length, this.SLOPE_WIDTH / 4, (x) => Math.sin(x * 0.018)); // simple sine
    startPosZ += length + spaceBetween;

    await this.generateLine(path, doorIndex, startPosZ, length, this.SLOPE_WIDTH / 2, (x) => Math.sin(x * 0.018)); // sine
    startPosZ += length + spaceBetween;

    await this.generateLine(path, doorIndex, startPosZ, length, this.SLOPE_WIDTH / 2, (x) => Math.sin(x * 0.025) * 0.3 + Math.sin(x * 0.005)); // very little waves
    startPosZ += length + spaceBetween;

    await this.generateLine(path, doorIndex, startPosZ, length, this.SLOPE_WIDTH / 2, (x) => Math.sin(x * 0.025) * 0.25 + Math.sin(x * 0.010)); // big waves
    startPosZ += length + spaceBetween;

    await this.generateLine(path, doorIndex, startPosZ, length, this.SLOPE_WIDTH / 2, (x) => Math.sin(x * 0.07) * 0.1 + Math.sin(x * 0.01)); // very little waves
    startPosZ += length + spaceBetween;

    await this.generateLine(path, doorIndex, startPosZ, length / 2, this.SLOPE_WIDTH / 2, (x) => Math.sin(x * 0.03) * 0.2 + Math.sin(x * 0.01)); // hard waves
    startPosZ += length + spaceBetween;

    // await this.generateLine(path, doorIndex, startPosZ, length, this.SLOPE_WIDTH / 2, (x) => Math.sin(x * 0.018)); // simple sine
    // startPosZ += length + spaceBetween;

    console.log("doors = " + this.doors.length)
    console.log("boosts = " + this.boosts.length)
    // this.doors[this.doors.length - 1].setFinishMaterial();
    if (this.doors.length > 0) this.nextDoor = this.doors[0];
    if (this.boosts.length > 0) this.nextBoost = this.boosts[0];


    // Start line
    const redLineMaterial = new StandardMaterial("finishLineMat", this.scene!);
    redLineMaterial.diffuseColor = Color3.FromHexString("#FF0000");
    redLineMaterial.alpha = 0.3

    const startLine = line2D("startline", { path: [new Vector3(-this.SLOPE_WIDTH, 0.01, -this.SLOPE_LENGTH / 2), new Vector3(this.SLOPE_WIDTH, 0.01, -this.SLOPE_LENGTH / 2)], width: 2, closed: false, standardUV: true }, this.scene!);
    startLine.material = redLineMaterial;
    startLine.parent = this.ground;

    const poleMaterial = new StandardMaterial("poleRedMaterial");
    (poleMaterial as StandardMaterial).diffuseColor = Color3.Red();

    const leftPole = MeshBuilder.CreateBox("pole", { height: 1.5, width: .3, depth: .3 }, scene);
    leftPole.material = poleMaterial;
    leftPole.position.x = -1
    leftPole.position.z = -6
    leftPole.parent = decorsParent;
    const rightPole = MeshBuilder.CreateBox("pole", { height: 1.5, width: .3, depth: .3 }, scene);
    rightPole.material = poleMaterial;
    rightPole.position.x = 1
    rightPole.position.z = -6
    rightPole.parent = decorsParent;

    // Finish line
    this.finishLine = line2D("finishline", { path: [new Vector3(-this.SLOPE_WIDTH, 0.01, this.SLOPE_LENGTH / 2), new Vector3(this.SLOPE_WIDTH, 0.01, this.SLOPE_LENGTH / 2)], width: 2, closed: false, standardUV: true }, this.scene!);
    this.finishLine.material = redLineMaterial;
    this.finishLine.parent = this.ground;

    const leftPoleFL = MeshBuilder.CreateBox("leftPole", { height: 20, width: 5, depth: 5 }, scene);
    leftPoleFL.material = poleMaterial;
    leftPoleFL.position.y = 10
    leftPoleFL.position.x = -this.SLOPE_WIDTH
    leftPoleFL.position.z = this.SLOPE_LENGTH - 5
    leftPoleFL.parent = decorsParent;

    const rightPoleFL = MeshBuilder.CreateBox("rightPole", { height: 20, width: 5, depth: 5 }, scene);
    rightPoleFL.material = poleMaterial;
    rightPoleFL.position.y = 10
    rightPoleFL.position.x = this.SLOPE_WIDTH
    rightPoleFL.position.z = this.SLOPE_LENGTH - 5
    rightPoleFL.parent = decorsParent;

    const centerPoleFL = MeshBuilder.CreateBox("centerPole", { height: 5, width: 5 + this.SLOPE_WIDTH * 2, depth: 5 }, scene);
    centerPoleFL.material = poleMaterial;
    centerPoleFL.position.y = 20
    centerPoleFL.position.x = 0; //this.SLOPE_WIDTH
    centerPoleFL.position.z = this.SLOPE_LENGTH - 5
    centerPoleFL.parent = decorsParent;

    // Barriers
    this.generateBarrier("barrier-left", scene, { x: -((this.SLOPE_WIDTH + 80) / 2), y: -1.25, z: 0, rotation: -90, length: this.SLOPE_LENGTH, parent: decorsParent });
    this.generateBarrier("barrier-right", scene, { x: ((this.SLOPE_WIDTH + 80) / 2), y: -1.25, z: 0, rotation: 90, length: this.SLOPE_LENGTH, parent: decorsParent });

    const lengthBarrier = this.SLOPE_WIDTH * 2;
    this.generateBarrier("barrier-left_end", scene, { x: -((this.SLOPE_WIDTH + 80) / 2) - lengthBarrier / 2.9, y: -1.25, z: this.SLOPE_LENGTH + lengthBarrier / 1.05, rotation: 70 + 180, length: lengthBarrier, parent: decorsParent });
    this.generateBarrier("barrier-right_end", scene, { x: ((this.SLOPE_WIDTH + 80) / 2) + lengthBarrier / 2.9, y: -1.25, z: this.SLOPE_LENGTH + lengthBarrier / 1.05, rotation: -70 + 180, length: lengthBarrier, parent: decorsParent });
    this.generateBarrier("barrier-end", scene, { x: 0, y: -1.25, z: this.SLOPE_LENGTH + lengthBarrier * 1.88, rotation: 0, length: lengthBarrier * 1.2, parent: decorsParent });

    // START
    scene.physicsEnabled = true;
    this.gameReady = true;
  };

  generateBarrier(name: string, scene: Scene, args: { x: number; y: number; z: number; rotation: number; length: number; parent: Node }) {
    const physicalMesh = MeshBuilder.CreatePlane(name + "-collider", { width: args.length * 2, height: 20 }, scene);
    physicalMesh.position.x = args.x;
    physicalMesh.position.y = args.y;
    physicalMesh.position.z = args.z;
    physicalMesh.rotate(physicalMesh.up, Angle.FromDegrees(args.rotation).radians())
    physicalMesh.isVisible = false;
    physicalMesh.parent = args.parent;
    const barrierAgr = new PhysicsAggregate(physicalMesh, PhysicsShapeType.BOX, { mass: 0, friction: 0, restitution: 0 }, scene);

    const height = 10;
    const barrierVisibleMesh = MeshBuilder.CreatePlane(name + "-collider", { width: args.length * 2, height: height }, scene);
    const barrierMaterial = new StandardMaterial("barrierMaterial");
    barrierMaterial.diffuseTexture = new Texture(barrierTexture, scene, false, false);
    barrierMaterial.useAlphaFromDiffuseTexture = true;
    (barrierMaterial.diffuseTexture as Texture).uScale = args.length * 2;
    (barrierMaterial.diffuseTexture as Texture).vScale = height * 2;
    barrierMaterial.diffuseTexture.hasAlpha = true;
    barrierMaterial.alphaCutOff = 0.5;
    barrierMaterial.transparencyMode = 3;
    barrierMaterial.alphaMode = 2;
    barrierVisibleMesh.material = barrierMaterial;
    // this._barrierMesh.getChildMeshes().forEach(mesh => {
    //   const instance = (mesh as Mesh).createInstance(name + "-" + mesh.name + "-mesh")
    //   instance.isVisible = true;
    //   instance.parent = barrierVisibleMesh;
    // });
    barrierVisibleMesh.parent = physicalMesh;
    // barrierVisibleMesh.rotate(barrierVisibleMesh.up, Angle.FromDegrees(90).radians())
    // barrierVisibleMesh.scaling = new Vector3(1, 3, args.length);
  }

  async generateLine(path: Vector3[], doorIndex: number, startZ: number, length: number, curveWidth: number, mainCurve: (x: number) => number) {
    let lastDoorPosition: Vector3 | null = null
    let lastTurnWasLeft = false;
    let turnLeft = false
    const CURVE_RESOLUTION = 1;
    const endZ = startZ + length;
    const linePath = []
    for (let t = startZ; t <= endZ; t += CURVE_RESOLUTION) {
      let curve = (x: number) => { return mainCurve(x) * curveWidth };
      const pos = new Vector3(curve(t), 0.1, t)
      const posB = new Vector3(curve(t + 1), 0.1, (t + 1))
      let tangente = (posB.x - pos.x) / (posB.z - pos.z)
      if (linePath.length != 0) linePath.push(pos)
      const shouldSpawn = Math.abs(tangente) < 0.1 // lastDoorPosition == null || pos.z >= lastDoorPosition.z + SINE_PERIOD
      turnLeft = tangente > 0
      if (shouldSpawn && turnLeft !== lastTurnWasLeft) {
        if (linePath.length === 0) linePath.push(pos)
        const doorPosition = new Vector3(pos.x + ((turnLeft ? 1 : -1) * 5), pos.y, pos.z);
        const door = new Door(this.scene!, doorIndex++, doorPosition, turnLeft)
        await door.init(this.scene!);
        door.rootMesh!.parent = this.ground;
        this.doors.push(door)

        // const ramp = new Ramp(scene, doorIndex, doorPosition)
        // await ramp.init(scene);
        // ramp.mesh.parent = this.ground;
        // this.ramps.push(ramp)

        if (lastDoorPosition != null) {
          const distanceBetweenDoors = doorPosition.z - lastDoorPosition?._z
          if (distanceBetweenDoors >= 92) {
            const boostPosition = new Vector3(pos.x + ((turnLeft ? 1 : -1) * 40), pos.y, pos.z - distanceBetweenDoors / 1.5);
            const boost = new Boost(this.scene!, doorIndex, boostPosition)
            await boost.init(this.scene!);
            boost.mesh!.parent = this.ground;
            this.boosts.push(boost)
          }
        }

        lastDoorPosition = doorPosition
        lastTurnWasLeft = turnLeft;

        if (endZ - t <= (startZ - endZ) / 10) break;
      }
    }
    path = [...path, ...linePath];

    // draw line
    if (path.length >= 2) {
      const line = line2D("line", { path: path, width: .5, closed: false, standardUV: true }, this.scene!);
      const lineMaterial = new StandardMaterial("lineMat", this.scene!);
      lineMaterial.diffuseColor = Color3.FromHexString("#0011FF");
      lineMaterial.alpha = 0.3
      line.material = lineMaterial;
      line.parent = this.ground;
    }

  }


  DOOR_BONUS = 0;
  BOOST_BONUS = 500;
  SPEED_INCREASE_OVER_TIME = 0.01;
  currentSteerForce = 3500;
  currentForwardSpeed = 2500;
  forwardSpeedMult = 1;
  steerForceMult = 1;

  lastjump = 0;
  jumpCooldown = 700; // 2000 milliseconds = 2 seconds

  gameStarted = false;
  previousLinearXvelocity = 0;
  previousLinearZvelocity = 0;
  onUpdate = (scene: Scene) => {
    // CAMERA
    // this.camera?.update()
  };

  onPhysicsUpdate = (scene: Scene) => {
    if (!this.gameReady || !this.player || !this.player.rg) return;

    this.player.update();

    if (!this.gameStarted) {
      this.player.lean(true);
      if (this.controls.isUp) {
        this.gameStarted = true;
        this.chrono.start();
        (this.camera as FollowCamera).heightOffset = 15;
        (this.camera as FollowCamera).cameraAcceleration = 0.03;
        this.player.unfreeze();
        this.player.rg.body?.applyImpulse(
          new Vector3(0, 500, 2000),
          this.player.mesh.position
        );
        this.driftSound?.play()
        this.startSound?.play()
      }
      return;
    }

    this.currentForwardSpeed += this.SPEED_INCREASE_OVER_TIME;

    // INPUTS
    if (this.controls.isRestart) {
      this.restart()
    }

    if (!this.finished) {
      const duckSpeedMult = 1.35;
      const breakSpeedMult = 0.4;
      if (isOnMobile()) {
        this.forwardSpeedMult = 1 + Math.abs(this.controls.vertical) * (this.controls.vertical > 0 ? duckSpeedMult - 1 : -(1 - breakSpeedMult));
        this.steerForceMult = 0.55;
        if (this.controls.isDown) {
          (this.camera as FollowCamera).radius = 20;
          this.player.break(true);
        }
        else if (this.controls.isUp) {
          this.player.break(false);
          (this.camera as FollowCamera).heightOffset = 8;
          this.player.lean(true);
          this.backgroundSound?.setVolume(1, 0.2)
        } else {
          this.steerForceMult = 1;
          this.player.break(false);
          (this.camera as FollowCamera).heightOffset = 15;
          this.player.lean(false);
          this.backgroundSound?.setVolume(0.5, 0.2)
        }

        this.player.rg.body.applyForce(
          new Vector3(-this.currentSteerForce / 1.2 * this.steerForceMult * this.controls.horizontal, 0, 0), // direction and magnitude of the applied force
          this.player.mesh.position // point in WORLD space where the force will be applied
        );
      }
      else {
        if (this.controls.isDown) {
          this.forwardSpeedMult = 0.4;
          this.steerForceMult = 0.55;
          (this.camera as FollowCamera).radius = 20;
          this.player.break(true);
        }
        else if (this.controls.isUp) {
          this.player.break(false);
          (this.camera as FollowCamera).heightOffset = 8;
          this.forwardSpeedMult = 1.35;
          this.steerForceMult = 0.55;
          this.player.lean(true);
          this.backgroundSound?.setVolume(1, 0.2)
        } else {
          this.player.break(false);
          (this.camera as FollowCamera).heightOffset = 15;
          this.forwardSpeedMult = 1;
          this.steerForceMult = 1;
          this.player.lean(false);
          this.backgroundSound?.setVolume(0.5, 0.2)
        }

        if (this.controls.isLeft) {
          this.player.rg.body.applyForce(
            new Vector3(-this.currentSteerForce / 1.2 * this.steerForceMult, 0, 0), // direction and magnitude of the applied force
            this.player.mesh.position // point in WORLD space where the force will be applied
          );
        }
        else if (this.controls.isRight) {
          this.player.rg.body.applyForce(
            new Vector3(this.currentSteerForce / 1.2 * this.steerForceMult, 0, 0), // direction and magnitude of the applied force
            this.player.mesh.position // point in WORLD space where the force will be applied
          );
        }
      }

      this.player.rg.body.applyForce(new Vector3(0, 0, this.currentForwardSpeed * this.forwardSpeedMult), // direction and magnitude of the applied force
        this.player.mesh.position // point in WORLD space where the force will be applied
      );
    }

    if (this.nextDoor != null && this.nextDoor.rootMesh != null) {
      // If player goes further than next door
      if (this.player.mesh.getAbsolutePosition().z >= this.nextDoor.rootMesh.getAbsolutePosition().z) {
        const playerDistanceFromDoor = this.player.mesh.getAbsolutePosition().x - this.nextDoor.rootMesh.getAbsolutePosition().x;
        const playerSpeed = this.player.rg.body.getLinearVelocity().length();
        if (!this.nextDoor.shouldGoLeft && this.player.mesh.getAbsolutePosition().x > this.nextDoor.rootMesh.getAbsolutePosition().x || this.nextDoor.shouldGoLeft && this.player.mesh.getAbsolutePosition().x < this.nextDoor.rootMesh.getAbsolutePosition().x) {
          this.currentForwardSpeed += this.DOOR_BONUS;
          this.nextDoor.setActivated();
          this.nextDoor._playSfx(playerDistanceFromDoor, playerSpeed);
        } else {
          this.nextDoor.setFailed();
          this.nextDoor._playSfx(playerDistanceFromDoor, playerSpeed);
          this.chrono.addPenalty(10);
        }

        const newIndex = this.doors.indexOf(this.nextDoor) + 1
        if (newIndex < this.doors.length) {
          const newDoor = this.doors[this.doors.indexOf(this.nextDoor) + 1];
          this.nextDoor = newDoor;
        } else this.nextDoor = null;
      }
    }

    // Finish condition
    if (!this.finished && this.player.mesh.getAbsolutePosition().z >= this.SLOPE_LENGTH) {
      this.finished = true;
      const time = this.chrono.stop()
      const totalTime: number = this.chrono.penalties + time
      this.startSound?.play()
      this.nextDoor = null;
      console.log("RunTime = " + time + "s");
      console.log("Penalties = +" + this.chrono.penalties + "s");
      console.log("Final time = " + totalTime + "s");
      this.onGameFinished?.(totalTime);

      (this.camera as FollowCamera).radius = 50;
      (this.camera as FollowCamera).heightOffset = 50;
      (this.camera as FollowCamera).cameraAcceleration = 0.005;
      (this.camera as FollowCamera).lowerRadiusLimit = 50;
      (this.camera as FollowCamera).upperRadiusLimit = 50;
      // (this.camera as FollowCamera).setTarget(new Vector3(0, 0, this.SLOPE_LENGTH + 100));
      (this.camera as FollowCamera).update();
      this.player!.rg!.body.setLinearDamping(1);

      setTimeout(() => {
        this.player!.rg!.body.setLinearDamping(10000);
        this.player?.snowParticles.stop()
      }, 5000)

      setTimeout(() => {
        this.cheerloopSound?.setVolume(0, 20)
        this.bellSound?.setVolume(0, 20)
      }, 10000)

      this.cheerloopSound?.setVolume(0)
      this.cheeringSound?.setVolume(0)
      this.bellSound?.setVolume(0)

      this.cheerloopSound?.play()
      this.cheeringSound?.play()
      this.bellSound?.play()

      this.cheerloopSound?.setVolume(0.8, 1)
      this.cheeringSound?.setVolume(1.5, 1)
      this.bellSound?.setVolume(1, 1)
    }
    // if (this.finished) (this.camera as FollowCamera).rotationOffset += (this.scene?.deltaTime ?? 0) / 100;

    if (this.nextBoost != null && this.nextBoost.mesh != null) {
      if (this.player.mesh.getAbsolutePosition().z >= this.nextBoost.mesh.getAbsolutePosition().z && this.player.mesh.getAbsolutePosition().z <= this.nextBoost.mesh.getAbsolutePosition().z + this.nextBoost.getHeight() / 1) {
        if (this.player.mesh.getAbsolutePosition().x >= this.nextBoost.mesh.getAbsolutePosition().x - this.nextBoost.getWidth() / 1 && this.player.mesh.getAbsolutePosition().x <= this.nextBoost.mesh.getAbsolutePosition().x + this.nextBoost.getWidth() / 1) {
          this.nextBoost.activate();
          // add force
          this.player.rg.body?.applyImpulse(new Vector3(this.player.mesh.forward.x * this.BOOST_BONUS, this.player.mesh.forward.y * this.BOOST_BONUS, this.player.mesh.forward.z * this.BOOST_BONUS), // direction and magnitude of the applied force
            this.player.mesh.position
          );
        }

        const newIndex = this.boosts.indexOf(this.nextBoost) + 1
        if (newIndex < this.boosts.length) {
          const newBoost = this.boosts[this.boosts.indexOf(this.nextBoost) + 1];
          this.nextBoost = newBoost;
        } else {
          this.nextBoost = null;
        }
      }
    }

    // SOUND
    let volume = (this.player.rg.body.getLinearVelocity().z / 1000);
    if (this.player.mesh.getAbsolutePosition().y >= 0.1) volume = 0;
    else {
      volume += (this.player.rg.body.getLinearVelocity().z / 200) * Math.abs(this.previousLinearXvelocity - this.player.rg.body.getLinearVelocity().x) / 2;
      volume += Math.max(0, this.previousLinearZvelocity - this.player.rg.body.getLinearVelocity().z) * 2;
    }
    this.player.setParticleRate(volume);
    this.previousLinearXvelocity = this.player.rg.body.getLinearVelocity().x;
    this.previousLinearZvelocity = this.player.rg.body.getLinearVelocity().z;
    this.driftSound?.setVolume(volume, 0.05)
  }
}

